import Component from '@glimmer/component';

import { concat } from '@ember/helper';
import noop from '@nullvoxpopuli/ember-composable-helpers/helpers/noop';
import queue from '@nullvoxpopuli/ember-composable-helpers/helpers/queue';
import LinksTo from 'ember-route-state/components/links-to.gjs';

import concatClasses from 'rise-ui/helpers/concat-classes.js';
import fnx from 'rise-ui/helpers/fnx.js';

export default class DropdownListButtonLinkComponent extends Component {
  <template>
    <div role="menuitem"
      class={{concatClasses
        @mixClass
        (if @disabled "disabled")
        (concat "qa-ddlbi--" @key)
      }}
      ...attributes
    >
      <LinksTo
        @url={{@url}}
        @urlOpen={{@urlOpen}}
        @route={{@route}}
        @routeOpen={{@routeOpen}}
        @open={{@open}}
        @classMix={{@classMix}}
        @disabled={{@disabled}}
        @model={{@model}}
        @models={{@models}}
        @query={{@query}}
        @rel={{@rel}}
        @target={{@target}}
        @classModConfig={{@classModConfig}}
        @title={{@title}}
        @preventDefault={{@preventDefault}}
        @defaultLink={{@defaultLink}}
        @noOpenIcon={{@noOpenIcon}}
        @onClick={{if @disabled (noop) (queue (fnx @onSelection @key) (fnx @onClick @key))}}
      >
        {{~yield~}}
      </LinksTo>
    </div>
  </template>
}
